import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import AnimationProgress from '../../../assets/gfx/animation-progress.gif';

ReactModal.setAppElement('#root');

const ProgressModal = (props) => {

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if(props.progressModalIsOpen)  setShowModal(true);
    }, [props.progressModalIsOpen]);

    return (
        showModal && (
            <ReactModal
                className="youtube-modal"
                overlayClassName="modal-overlay white"
                isOpen={showModal}
                contentLabel="Youtube modal">
                <div className="max-width-5 mx-auto clearfix">
                    <div className="col col-12 px2">
                        <div className="youtube-content">
                            <div className="youtube-iframe-container preloader">
                    
                                <div className="clearfix mx-auto preloader-wrapper">
                                    <div className="col col-12">
                                        <img src={process.env.NODE_ENV !== 'production' ? AnimationProgress : 'https://www.busabout.com/__data/assets/git_bridge/0023/83552/app/build/static/media/animation-progress.gif'} alt="progress" />
                                        <p className="margin-t-30">We are putting together your itinerary.</p>
                                        <p>Please do not refresh your browser as this process can take up to 60 seconds.</p>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>                    
        )
    )

}

const mapStateToProps = state => {
    return{
        progressModalIsOpen:state.toggleModal.progressModalIsOpen
    }
}

export default connect(mapStateToProps, null)(ProgressModal);